module.exports = __webpack_public_path__ + "static/media/game-controller-mtn-retro.3a4ed92a.png";